export const state = () => ({
    disableScrollToTop: false,
    lastScrollPosition: 0,
    lastPage: null
});

export const mutations = {
    SET_DISABLE_SCROLL_TO_TOP: (state, value) => (state.disableScrollToTop = value),
    SET_LAST_SCROLL_POSITION: (state, position) => (state.lastScrollPosition = position),
    SET_LAST_PAGE: (state, page) => (state.lastPage = page)
};

export const getters = {
    shouldScrollToTop: state => !state.disableScrollToTop,
    getLastScrollPosition: state => state.lastScrollPosition,
    getLastPage: state => state.lastPage
};

export const actions = {
    savePageAndPosition({ commit }, { page, scrollPosition }) {
        commit('SET_LAST_PAGE', page);
        commit('SET_LAST_SCROLL_POSITION', scrollPosition);
    },

    restoreLastScrollPosition: (context, page) => {
        if (!process.client || typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        if (page === context.state.lastPage) {
            if (document.documentElement.scrollHeight >= context.state.lastScrollPosition) {
                window.scrollTo(0, context.state.lastScrollPosition);
            } else {
                try {
                    const productsCatalogOffsetTop = 340.5;
                    const productsCatalogRowHeight = 460.8;
                    const rowsPerPage = 5;
                    const rowsGap = 20;
                    const productsCatalogHeight = productsCatalogRowHeight * rowsPerPage + (rowsGap * rowsPerPage - 1);
                    const howMuchloadedMoreOnPreviousPage = Math.floor(
                        (context.state.lastScrollPosition - productsCatalogOffsetTop) / productsCatalogHeight
                    );
                    const selectedProductRowHeight =
                        context.state.lastScrollPosition - howMuchloadedMoreOnPreviousPage * productsCatalogHeight;
                    window.scrollTo(0, selectedProductRowHeight);
                } catch (e) {
                    window.scrollTo(0, 0);
                }
            }
        }
        context.commit('SET_LAST_SCROLL_POSITION', null);
        context.commit('SET_LAST_SCROLL_POSITION', 0);
    },

    resetLastScrollAndPagePosition: context => {
        context.commit('SET_LAST_PAGE', null);
        context.commit('SET_LAST_SCROLL_POSITION', 0);
    }
};
